import { gql } from "graphql-request";
export const POST_GET_POST_BY_ID = gql`
    query getPostById($id: Int, $domainId: Int) {
        post(id: $id, published: true, domainId: $domainId) {
            excerpt
            title
            body
            categoryId
            createdAt
            updatedAt
            publishedAt
            related {
                title
                url {
                    isMain
                    main {
                        url
                    }
                    url
                }
            }
            translations {
                key
                value
                language
            }
            image {
                fullPath
                caption
                alt
            }
            tags {
                id
                name
                slug
                isPublished
            }
            urls {
                isMain
                language
                main {
                    url
                }
                url
            }
            url {
                isMain
                language
                main {
                    url
                }
                url
            }
            metatags {
                key
                value
            }
            writerUser {
                nickname
                nicknameSlug
                bio
                position
            }
            editorUser {
                nickname
                nicknameSlug
            }
        }
    }
`;
